var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { SsoLoginRequirement } from '@lucidlink/dto/validation';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { LOGIN_WIZARD_STEPS, useDependency, useGetAuthCodeHandler, useImperativeGetUserLoginConfig, useSSOClient, useSubscribeToBroadcastMessage, } from '@lucidlink/workspacemanagement';
export const useLoginEmail = ({ handleGeneralLoginError, setAccessToken, setLoginEmail, setNextStep, }) => {
    _react_refresh_temp_1();
    const { errors, formData } = useFormRoot();
    const clientBaseUrl = useDependency('CLIENT_BASE_URL');
    const { exchangeCode, initializeAuthentication } = useSSOClient();
    const onAuthCodeReceived = useGetAuthCodeHandler({
        exchangeCode,
        handleGeneralLoginError,
        loginEmail: formData.email || '',
        setAccessToken,
        setNextStep,
    });
    useSubscribeToBroadcastMessage({
        callback: onAuthCodeReceived,
        messageType: 'auth-code-received',
    });
    const { mutateAsync: getUserLoginConfigPromise } = useImperativeGetUserLoginConfig();
    const { isPending: isPendingSubmit, mutate: submit } = useMutation({
        mutationFn: async () => {
            const { email } = formData;
            if (!email) {
                return;
            }
            const userLoginConfig = await getUserLoginConfigPromise({
                userEmail: email,
            });
            if (!userLoginConfig) {
                return;
            }
            const { isWorkspaceNameRequired, ssoLoginParams, ssoLoginRequirement, } = userLoginConfig;
            setLoginEmail(email);
            switch (ssoLoginRequirement) {
                case SsoLoginRequirement.ALLOWED:
                case SsoLoginRequirement.DISABLED:
                    setNextStep(LOGIN_WIZARD_STEPS.PASSWORD);
                    break;
                case SsoLoginRequirement.REQUIRED:
                    // If > 1 workspace has SSO, we do not have ssoLoginParams,
                    // user must select workspace first to receive correct ssoLoginParams
                    if (isWorkspaceNameRequired) {
                        setNextStep(LOGIN_WIZARD_STEPS.WORKSPACE_NAME);
                        return;
                    }
                    // if `isWorkspaceNameRequired` is false, we must have SSO params
                    // to proceed immediately with SSO login
                    // TODO: Should we reset the form here? Otherwise what, nothing happens?
                    // No indication of anything happening is weird UX-wise
                    if (!ssoLoginParams) {
                        return;
                    }
                    await initializeAuthentication({
                        clientId: ssoLoginParams.clientId,
                        serverUri: ssoLoginParams.openIdConnectUrl,
                        redirectUri: `${clientBaseUrl}/sso-landing`,
                        loginHint: formData.email || '',
                    });
                    break;
                default:
                    break;
            }
        },
        onError: () => {
            handleGeneralLoginError();
        },
    });
    return {
        onContinue: submit,
        isLoadingUserLoginConfig: isPendingSubmit,
        formErrors: errors,
    };
};
_react_refresh_temp_1(useLoginEmail, "Wnh2gDSzjwEfnVH3Rr7fSNmpKRg=", false, () => [useFormRoot, useDependency, useSSOClient, useGetAuthCodeHandler, useSubscribeToBroadcastMessage, useImperativeGetUserLoginConfig, useMutation]);
